module.exports = __webpack_public_path__ + "img/4-PVR-activated.370c0fdc.png";